import createDuck from '../lib/MetagnosticDuck'
import ActionTypes from '../actions/ActionTypes.js'
import { getAppDoc, getAppDocs } from '../lib/APIClient'

export type AppDoc = {
  _id: string, 
  docType: string, 
  name: string,
  data: any,
}

export const emptyAppDoc: AppDoc = {
  _id: "id",
  docType: "type", 
  name: "unnamed",
  data: null,
}

const duck = createDuck(
  "APPDOCS", 
  getAppDoc, 
  getAppDocs, 
  {
    // custom actions
  }, 
  emptyAppDoc, 
  {
    // custom reducers
  }, 
  { 
    expunge: false, 
  }
)

export const createDoc = duck.actions.createDoc
export const receiveDocs = duck.actions.receiveCollection
export const receiveDoc = duck.actions.receiveDoc
export const removeDoc = duck.actions.removeDoc
export const fetchDocs = duck.actions.fetchCollection
export const updateDoc = duck.actions.updateDoc

export default duck

